import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './components/App';
import { BrowserRouter } from 'react-router-dom';
import Auth0ProviderWithRedirectCallback from './components/auth0/auth0-provider-with-redirect-callback';
import auth0Config from './components/auth0/config.json';

declare global {
  interface Window {
    gbl_service_urls: any;
    gbl_ui_urls: any;
    auth0_settings?: { domain: string; clientId: string; audience: string };
  }
}

// Prefer runtime auth settings injected via settings.js — the deployment
// overrides that file per-environment with a Terraform-generated ConfigMap, so
// the Auth0 SPA client id / domain / audience are live per env. Fall back to the
// build-time config.json for local dev and tests where no override is mounted.
const authSettings = window.auth0_settings ?? auth0Config;

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Auth0ProviderWithRedirectCallback
        cacheLocation="localstorage"
        domain={authSettings.domain}
        clientId={authSettings.clientId}
        authorizationParams={{
          audience: authSettings.audience,
          scope: 'profile email',
          redirect_uri: window.location.origin
        }}
      >
        <App />
      </Auth0ProviderWithRedirectCallback>
    </BrowserRouter>
  </React.StrictMode>
);
